import { Table } from 'antd';
import IColumn from '../../../interfaces/IColumn';
import '../DataGrid/DataGrid.css';

interface Props {
    dataSource: any[];
    columns: IColumn[];
    loading: boolean;
    props?: any;
    paginationActive?: boolean;
}

const DetailTable = ({ dataSource, columns, loading, props, paginationActive = true }: Props) => {
    return (
        <div className="grid pagination_box">
            <Table
                {...props}
                dataSource={dataSource}
                columns={columns}
                loading={loading}
                pagination={{ pageSize: 2, disabled: !paginationActive }}
            />
        </div>
    );
}


export default DetailTable;